import { Skeleton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useUsuario } from "../../../../providers/usuarioProvider";
import CardInformacaoAssinatura from "./cardInformacaoAssinatura";
import { IconUser } from "@tabler/icons-react";
import { keys } from "lodash";
import { getDoc } from "firebase/firestore";
import UsuarioDb from "../../../../db/usuarioDb";
import Usuario from "../../../../models/usuario";

export default function CardInformacoesPessoais() {
  const { visualizado } = useUsuario();
  const [usuarioVisualizado, setUsuarioVisualizado] = useState<Usuario>();

  useEffect(() => {
    if (visualizado) {
      getDoc(new UsuarioDb().doc({ usuarioId: visualizado })).then(
        (snapshot) => {
          setUsuarioVisualizado(snapshot.data());
        }
      );
    }
  }, [visualizado]);

  return (
    <CardInformacaoAssinatura
      titulo="Informações pessoais"
      Icone={IconUser}
      conteudo={
        !!usuarioVisualizado ? (
          <>
            {"Você importou "}
            <Typography variant="dataMono" fontSize={13} color="text.primary">
              {usuarioVisualizado.estatisticas?.notas ?? 0}
            </Typography>
            {" notas em "}
            <Typography variant="dataMono" fontSize={13} color="text.primary">
              {keys(usuarioVisualizado.estatisticas?.impostos).length}
            </Typography>
            {" meses."}
          </>
        ) : (
          <Skeleton variant="text" animation={false} />
        )
      }
      destaque={usuarioVisualizado?.nome ?? "-"}
      rodape={
        <Typography variant="dataMono" fontSize={12} color="text.secondary">
          {usuarioVisualizado?.email ?? "-"}
        </Typography>
      }
    />
  );
}
